import React, { useState } from 'react';
import { Modal, Paper, TextField, Button, LinearProgress } from '@material-ui/core';
import CloseIcon from '@mui/icons-material/Close';
import { useDispatch } from 'react-redux';

import { showErrorAction } from 'containers/Notification/actions';
import { useUpdateNonprofitNominationMutation, NonprofitNomination } from 'generated/graphql';

const InternalNoteModal = ({
  nomination,
  handleCloseNoteModal,
}: {
  nomination: NonprofitNomination;
  handleCloseNoteModal: () => void;
}): JSX.Element => {
  const dispatch = useDispatch();
  const [updateNonprofitNominationMutation, { loading }] = useUpdateNonprofitNominationMutation();

  const [updatedInternalNote, setUpdatedInternalNote] = useState(nomination.internalNote);

  const handleSubmitNote = async (): Promise<void> => {
    try {
      await updateNonprofitNominationMutation({
        variables: {
          updateNonprofitNominationId: nomination.id,
          data: {
            internalNote: updatedInternalNote,
          },
        },
      });
      handleCloseNoteModal();
    } catch (e) {
      dispatch(showErrorAction('There was an error updating this nomination'));
    }
  };

  return (
    <Modal
      open
      onClose={handleCloseNoteModal}
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
      disableAutoFocus
    >
      <Paper style={{ padding: 40, width: 600 }}>
        {loading ? (
          <LinearProgress style={{ width: '100%', top: '-20px' }} />
        ) : (
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'flex-start',
            }}
          >
            <CloseIcon
              style={{ cursor: 'pointer', marginBottom: 40 }}
              onClick={handleCloseNoteModal}
            />
          </div>
        )}
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            marginBottom: 40,
          }}
        >
          <TextField
            id="outlined-basic"
            placeholder="Update note"
            variant="outlined"
            multiline
            fullWidth
            onChange={(e): void => setUpdatedInternalNote(e.target.value)}
            disabled={loading}
            value={updatedInternalNote}
          />
        </div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
          }}
        >
          <Button
            disabled={loading}
            style={{ width: 250 }}
            onClick={handleCloseNoteModal}
            color="secondary"
          >
            Cancel
          </Button>
          <Button disabled={loading} style={{ width: 250 }} onClick={handleSubmitNote}>
            Submit
          </Button>
        </div>
      </Paper>
    </Modal>
  );
};

export default InternalNoteModal;
